import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const primary = defineStyle({
  borderRadius: "md",
  fontWeight: "semibold",
  color: "white",
  // untuk menghindari background initial
  _light: {
    background: "#3366FF",
  },
  _dark: {
    background: "#2746E6",
  },
  _disabled: {
    background: "#3b82f6",
  },
  _hover: {
    background: "#60a5fa",
  },
});

const danger = defineStyle({
  borderRadius: "md",
  fontWeight: "semibold",
  color: "white",
  // untuk menghindari background initial
  _light: {
    background: "#E21F39",
  },
  _dark: {
    background: "#ef4444",
  },
  _hover: {
    background: "#ED535A",
  },
});

const gray = defineStyle({
  borderRadius: "md",
  fontWeight: "semibold",
  color: "black",
  // untuk menghindari background initial
  _light: {
    background: "#edf2f7",
    color: "primary.500",
  },
  _dark: {
    background: "#334155",
    color: "white",
  },
});

const success = defineStyle({
  borderRadius: "md",
  fontWeight: "semibold",
  color: "white",
  background: "#54BF5E",
});

export const buttonTheme = defineStyleConfig({
  variants: { primary, danger, gray, success },
});
